export default __webpack_public_path__ + "static/media/AgriG8_Logo_COLOUR.e09201f1.png";